export default function SettingIcon() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.90432 6.58739C4.07307 6.23114 4.26994 5.89364 4.49494 5.56551L4.45744 3.12801C4.45744 2.90301 4.55119 2.68739 4.72932 2.53739C5.60119 1.80614 6.59494 1.21551 7.69182 0.821761C7.90744 0.746761 8.14182 0.765511 8.32932 0.887386L10.4199 2.14364C10.8137 2.11551 11.2074 2.11551 11.6012 2.14364L13.6918 0.887386C13.8887 0.774886 14.1231 0.746761 14.3387 0.821761C15.4074 1.20614 16.4106 1.77801 17.3012 2.52801C17.4699 2.66864 17.5731 2.89364 17.5637 3.11864L17.5262 5.55614C17.7512 5.88426 17.9481 6.22176 18.1168 6.57801L20.2449 7.75926C20.4418 7.87176 20.5824 8.05926 20.6199 8.28426C20.8168 9.39989 20.8262 10.5624 20.6199 11.6968C20.5824 11.9218 20.4418 12.1093 20.2449 12.2218L18.1168 13.403C17.9481 13.7593 17.7512 14.0968 17.5262 14.4249L17.5637 16.8624C17.5637 17.0874 17.4699 17.303 17.2918 17.453C16.4199 18.1843 15.4262 18.7749 14.3293 19.1686C14.1137 19.2436 13.8793 19.2249 13.6918 19.103L11.6012 17.8468C11.2074 17.8749 10.8137 17.8749 10.4199 17.8468L8.32932 19.103C8.13244 19.2155 7.89807 19.2436 7.68244 19.1686C6.61369 18.7843 5.61057 18.2124 4.71994 17.4624C4.55119 17.3218 4.44807 17.0968 4.45744 16.8718L4.49494 14.4343C4.26994 14.1061 4.07307 13.7686 3.90432 13.4124L1.77619 12.2311C1.57932 12.1186 1.43869 11.9311 1.40119 11.7061C1.20432 10.5905 1.19494 9.42801 1.40119 8.29364C1.43869 8.06864 1.57932 7.88114 1.77619 7.76864L3.90432 6.58739Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.0011 14.4999C13.4864 14.4999 15.5011 12.4852 15.5011 9.99991C15.5011 7.51463 13.4864 5.49991 11.0011 5.49991C8.51582 5.49991 6.5011 7.51463 6.5011 9.99991C6.5011 12.4852 8.51582 14.4999 11.0011 14.4999Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
